import React, { memo, useEffect, useCallback, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createSelector } from 'reselect';
import { useActivate } from 'react-activation';
import Swiper from 'react-id-swiper';
import 'swiper/css/swiper.css';

import { logging, logPostInfo } from '../../actions/log';
import { CONTEXT } from '../../config';
import styles from './WpBanner.module.less';
import { loggingADX, getUrlByTargetContent } from '../../utils/utils';
import { useInView } from 'react-intersection-observer';
import _LogInView from '../../components/_LogInView/_LogInView';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ data, logInfo }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const logInfoData = useSelector(selectLogInfo);

  const swiperEl = useRef(null);
  const [banners, setBanners] = useState(null);
  const [swiperParams, setSwiperParams] = useState(null);
  const [showSwiper, setShowSwiper] = useState(false);

  const LOG_ACTION_SOURCE = {
    c_action: `C_${logInfo?.clTag ?? 'Wallpaper'}_Banner`,
    c_action_btn: `C_${logInfo?.clTag ?? 'Wallpaper'}_Banner_btn`,
    c_action_adx: `C_${logInfo?.clTag ?? 'Wallpaper'}_Banner_ADX`,
    p_adx: `P_${logInfo?.clTag ?? 'Wallpaper'}_Banner_ADX`,
    source: `${logInfo.tag}_Banner`,
  };

  const [ref, inView] = useInView({
    threshold: 0,
  });

  useActivate(() => {
    // const swiper = swiperEl.current && swiperEl.current.swiper;
    // if (swiper) {
    //   swiper.update();
    // }
    // 处理切换回来 不滚动的问题
    setShowSwiper(false);
    setTimeout(() => {
      setShowSwiper(true);
    }, 25);
  });

  useEffect(() => {
    setTimeout(() => {
      setShowSwiper(true);
    }, 50);
  }, []);

  // useEffect(() => {
  //   if (inView && logInfo && logInfo.changView) {
  //     let { pageCardContentId } = data && data.dataList && data.dataList[0];
  //     if (data && data.dataList && data.dataList.length > 1) {
  //       pageCardContentId = data.dataList.reduce((total, item) => {
  //         return `${total}${total ? '||' : ''}${item.pageCardContentId}`;
  //       }, '');
  //     }
  //     logInfo.changView({
  //       pageCardId: pageCardContentId,
  //       pageCardTitle: data && data.title,
  //       rankCode: data && data.dataList && data.dataList[0] && data.dataList[0].code,
  //       cardType: data && data.cardType,
  //     });
  //   }
  // }, [inView]);

  // 筛洗数据，去除运营配置数据错误情况
  useEffect(() => {
    if (data && data.dataList) {
      const showBanners = [];
      let hasADXBanner = null;
      data.dataList.forEach(banner => {
        if (
          banner.targetType === '1' ||
          banner.targetType === '2' ||
          banner.targetType === '3' ||
          banner.targetType === '11'
        ) {
          showBanners.push(banner);
        }
        // 是否含有adx数据
        if (banner.targetType === '10' && banner.advertCrid && banner.advertUrl) {
          showBanners.push(banner);
          hasADXBanner = banner;
        }
      });
      setBanners(showBanners.slice(0, 10));
      getSwiperParams(showBanners.slice(0, 10));
      // 含有adx数据，则打展示的桩
      if (hasADXBanner) {
        loggingADXPV(hasADXBanner);
      }
    }
  }, []);

  // 由于swiper组件没有封装 hover切换事件，所以添加事件：鼠标hover切换轮播图。
  useEffect(() => {
    const swiper = swiperEl.current && swiperEl.current.swiper;
    if (banners && swiper) {
      const paginations = document.querySelectorAll('.swiper-pagination-bullet');
      paginations.forEach((pagination, index) => {
        pagination.addEventListener(
          'mouseenter',
          () => {
            swiper.slideTo(index + banners.length);
          },
          false,
        );
      });
    }
  }, [banners, swiperEl]);

  const loggingADXPV = useCallback(bannerADX => {
    // 推荐页面ADX banner展示打桩
    dispatch(
      logging({
        category: 'Wallpaper',
        action: LOG_ACTION_SOURCE.p_adx,
        label: '',
        param2: {
          source: LOG_ACTION_SOURCE.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          advertCrid: bannerADX.advertCrid,
          advertUrl: bannerADX.advertUrl,
        },
        param3: bannerADX.bizInfo,
      }),
    );
    if (bannerADX && bannerADX.impTracks) {
      const impTracks = JSON.parse(bannerADX.impTracks);
      loggingADX(impTracks);
    }
  }, []);

  const loggingADXClick = useCallback(bannerADX => {
    // 推荐页面ADX banner点击打桩
    dispatch(
      logging({
        category: 'Wallpaper',
        action: LOG_ACTION_SOURCE.c_action_adx,
        label: '',
        param2: {
          source: LOG_ACTION_SOURCE.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          advertCrid: bannerADX.advertCrid,
          advertUrl: bannerADX.advertUrl,
        },
        param3: bannerADX.bizInfo,
      }),
    );
    if (bannerADX && bannerADX.impTracks) {
      const clickTracks = JSON.parse(bannerADX.clickTracks);
      loggingADX(clickTracks);
    }
  }, []);

  const onChangeI = useCallback(changeData => {
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'I_Content_Show',
        label: '',
        param2: {
          // rankCode: JSON.parse(item?.targetContent).rankId,
          cardType: data?.cardType,
          pageCardTitle: data?.title ?? '',
          pageCardId: changeData?.pageCardContentId,
          source_p: logInfoData?.source_p,
          source: LOG_ACTION_SOURCE.source,
        },
        param3: data.bizInfo ?? null,
      }),
    );
  }, []);

  const getSwiperParams = useCallback(
    bannersArr => {
      const params = {
        speed: 800,
        loop: true,
        // loopPreventsSlide: false,
        slidesPerView: 'auto',
        centeredSlides: true,
        normalizeSlideIndex: false,
        grabCursor: true,
        centerInsufficientSlides: true,
        slideToClickedSlide: true,
        effect: 'coverflow',
        coverflowEffect: {
          rotate: 0,
          stretch: 1,
          depth: 150,
          modifier: 1,
          slideShadows: true,
        },
        autoplay: {
          delay: 4000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          renderBullet: (index, className) => {
            return `<div class="${className}">
            <div class="swiper_pagination_round"></div>
          </div>`;
          },
        },
        on: {
          click(e) {
            const targetDom = e.path[0] || {};
            const index = this.activeIndex % bannersArr.length;
            const bannerInfo = bannersArr[index] || {};
            if (targetDom.className && targetDom.className.indexOf(styles.banner_img) > -1) {
              handleBanner(bannerInfo);
            }
          },
          slideChangeTransitionStart(e) {
            const swiperObj = swiperEl.current.swiper;
            const activeIndex = ~~swiperObj?.activeIndex % data?.dataList?.length;

            if (data?.dataList?.[activeIndex]) {
              onChangeI(data?.dataList?.[activeIndex]);
            }
          },
        },
      };
      setSwiperParams(params);
    },
    [swiperEl, banners],
  );

  const goNext = () => {
    const nowTime = +new Date();
    let diffTime = nowTime - (window.swiperClickTime || 0);
    if (diffTime > 200) {
      diffTime = 200;
    }
    const swiper = swiperEl.current && swiperEl.current.swiper;
    if (swiper !== null) {
      swiper.slideNext(diffTime);
      window.swiperClickTime = nowTime;
    }
  };
  const goPrev = () => {
    const nowTime = +new Date();
    let diffTime = nowTime - (window.swiperClickTime || 0);
    if (diffTime > 200) {
      diffTime = 200;
    }
    const swiper = swiperEl.current && swiperEl.current.swiper;
    if (swiper !== null) {
      swiper.slidePrev(diffTime);
      window.swiperClickTime = nowTime;
    }
  };

  const handleBanner = useCallback(
    bannerInfo => {
      // 推荐页面banner点击打桩
      dispatch(
        logging({
          category: 'Wallpaper',
          action: LOG_ACTION_SOURCE.c_action,
          label: '',
          param2: {
            source: LOG_ACTION_SOURCE.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
          param3: bannerInfo.bizInfo,
        }),
      );

      setTimeout(() => {
        if (
          bannerInfo.targetType === '1' ||
          bannerInfo.targetType === '3' ||
          bannerInfo.targetType === '11'
        ) {
          dispatch(
            logPostInfo({
              source_p: LOG_ACTION_SOURCE.source,
              source_pp: logInfoData.source_p,
            }),
          );
          if (bannerInfo.targetType && bannerInfo.targetContent) {
            const url = getUrlByTargetContent(bannerInfo);
            history.push(url);
          }
        } else if (bannerInfo.targetType === '2' && bannerInfo.targetContent) {
          const targetContent = JSON.parse(bannerInfo.targetContent) || {};
          window.open(targetContent.targetUrl);
        } else if (
          bannerInfo.targetType === '10' &&
          bannerInfo.advertCrid &&
          bannerInfo.advertUrl
        ) {
          loggingADXClick(bannerInfo);
          window.open(bannerInfo.advertUrl);
        } else {
          history.push(`${CONTEXT}/error`);
        }
      }, 30);
    },
    [dispatch, logInfoData, history],
  );

  return banners && banners.length > 0 ? (
    <div className={styles.banner} ref={ref}>
      {inView && showSwiper && (
        <>
          <Swiper {...swiperParams} ref={swiperEl}>
            {banners.map((item, i) => (
              <div
                key={i}
                onMouseEnter={() => {
                  if (swiperEl.current.swiper) swiperEl.current.swiper.autoplay.stop();
                }}
                onMouseLeave={() => {
                  if (swiperEl.current.swiper) swiperEl.current.swiper.autoplay.start();
                }}
              >
                <div className={styles.banner_item} key={i}>
                  <img className={styles.banner_img} src={item.contentImg} alt="" />
                </div>
                <div className="swiper-slide-shadow-left" />
                <div className="swiper-slide-shadow-right" />
              </div>
            ))}
          </Swiper>
          <div className={styles.banner_swiper_prev} onClick={goPrev} />
          <div className={styles.banner_swiper_next} onClick={goNext} />
        </>
      )}
    </div>
  ) : (
    ''
  );
});
